import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';
import { mergeCls } from '../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = styled.div((p) => [
  CommonStyles,
  `
  border-radius: ${p.borderRadius ? p.theme.borderRadius[p.borderRadius] : p.theme.borderRadius.m};
  background-color: ${p.theme.colors.white};
  position: relative;
`
]);
const CardHeader = styled.div``;
const CardBody = styled.div``;
const CardFooter = styled.div``;
const Card = React__default.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ React__default.createElement(StyledCard, __spreadValues({
    className: mergeCls("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ React__default.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ React__default.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ React__default.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";

export { Card };
